// Formatters.js
export const formatCount = (count) => {
  if (count < 1000) {
    return count.toString(); // No formatting needed for numbers less than 1000
  } else if (count < 1000000) {
    // Format for thousands (k)
    const formatted = (count / 1000).toFixed(1);
    // Remove .0 if it exists
    return formatted.endsWith('.0') ? `${Math.floor(count / 1000)}K` : `${formatted}K`;
  } else {
    // Format for millions (m)
    const formatted = (count / 1000000).toFixed(1);
    // Remove .0 if it exists
    return formatted.endsWith('.0') ? `${Math.floor(count / 1000000)}M` : `${formatted}M`;
  }
};

// Format duration from seconds to mm:ss
export const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
};




